export function compare(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}

export function getFileName(response) {
    const contentDisposition = response.headers['content-disposition'];
    return contentDisposition.substr(contentDisposition.indexOf('filename=') + 9);
}

export function isoStrToAMPM(str) {
    if (str) {
        return formatAMPM(isoStrToDate(str))
    }
    return null;
}

export function isoStrToDate(str) {
    try {
        return new Date(str);
    } catch (ex) {
        // tslint:disable-next-line
        console.log(ex);
    }
}

export function isCoordValid(val) {
    if (val && Number(val) !== 0) {
        return true;
    }
    return false;
}

export function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

export function colorByEstado(estado) {
    if (estado === 'ACEPTADO') {
        return 'aceptado';
    } else if (estado === 'RECHAZADO') {
        return 'rechazado';
    } else if (estado === 'PARCIAL') {
        return 'parcial';
    } else {
        return 'pendiente';
    }
}

export function colorByDistancia(dist) {
    if (dist <= 50) {
        return 'aceptable';
    } else if (dist <= 100) {
        return 'regular';
    } else {
        return 'deficiente';
    }
}

export function distancia(lat1, lon1, lat2, lon2, unit) {
    if ((lat1 === lat2) && (lon1 === lon2)) {
        return 0;
    }
    else {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit === 'K') {
            dist = dist * 1.609344
        }
        if (unit === 'N') {
            dist = dist * 0.8684
        }
        if (unit === 'MM') {
            dist = dist * 1.609344 * 1000
        }
        return dist;
    }
}

export function formatearDecimal(val, cantDecimales) {
    var d = parseFloat(val);
    if (!isNaN(d)) {
        return d.toFixed(cantDecimales ? cantDecimales : 2);
    } else {
        return '';
    }

}

export function normalizarStr(str) {
    return str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : "";
}


export function obtenerArregloValores(obj) {
    var arrValores = [];
    for (const prop in obj) {
        if (obj[prop]) {
            if (typeof obj[prop] === 'string') {
                arrValores.push(normalizarStr(obj[prop]));
            } else {
                if (typeof obj[prop] === 'number') {
                    arrValores.push(formatearDecimal(obj[prop]));
                }
            }
        }
    }
    return arrValores;
}


export function contieneSimilar(arrValores, str) {
    const keyword = str ? str.toLowerCase().trim() : '';
    return arrValores.filter(function (el) {
        return el.indexOf(normalizarStr(keyword)) >= 0;
    }).length > 0;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js